import { render, staticRenderFns } from "./WeekPasswordTip.vue?vue&type=template&id=65c489c2"
import script from "./WeekPasswordTip.vue?vue&type=script&lang=js"
export * from "./WeekPasswordTip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports